var ShopProfile = (function () {
    var url = "https://www.erotikastore.eu";
    var getURLProfile = function () {
        return url;
    }
    //----> SET

    return {
        getURL: getURLProfile
        //-------
        //setIp: setIpProfile
    }
})();
export default ShopProfile;